import React from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";

import { Link } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import GridContainer from "../../material-dashboard/components/Grid/GridContainer.jsx";
import GridItem from "../../material-dashboard/components/Grid/GridItem.jsx";
import Button from "../../material-dashboard/components/CustomButtons/Button.jsx";
import Card from "../../material-dashboard/components/Card/Card.jsx";
import CardBody from "../../material-dashboard/components/Card/CardBody.jsx";

import Check from "@material-ui/icons/Check";

import consultationStyles from "../styles/consultationStyles.js";

import { trackVisitProductSelected } from "../utils/analytics";

import {
  getVisitProduct,
  setVisitProduct,
  getVisitID,
  isFollowUpVisit,
  getVisitDifferentPharmacyJSON,
} from "../utils/visitCookies";

import {
  ORDER_TYPE_PROP_1_PACK,
  ORDER_TYPE_PROP_1_PACK_FOLLOW_UP,
  ORDER_TYPE_PROP_2_PACK,
  ORDER_TYPE_PROP_2_PACK_FOLLOW_UP,
  ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_MONTHLY,
  ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_QUARTERLY,
  ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_SEMIANNUAL,
  ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_MONTHLY,
  ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_QUARTERLY,
  ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_SEMIANNUAL,
} from "../../shared/sharedConstants";

import { getSleepMailOrderOrVisitOnlyPrice } from "../../shared/utils/sharedUtils";
import {
  kickRed,
  kickBlue,
  kickNavy,
  kickAmaOrange,
} from "../../shared/styles/baseStyles.js";

// const store = createStore(VisitApp);
class SelectProductSleep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      consultationType: this.props.match.params.consultationType,
      selectedProduct: getVisitProduct() || "",
      // (isFollowUpVisit()
      //   ? ORDER_TYPE_PROP_2_PACK_FOLLOW_UP
      //   : ORDER_TYPE_PROP_2_PACK), // select 2-pack by default
      showError: false,
    };
  }

  handleSelection = async (selectedProduct) => {
    let modifiedProduct = selectedProduct;

    console.log("selectedProduct: ", selectedProduct);
    if (getVisitDifferentPharmacyJSON() != {}) {
      switch (selectedProduct) {
        case ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_MONTHLY:
          modifiedProduct = ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_MONTHLY;
          break;

        case ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_QUARTERLY:
          modifiedProduct = ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_QUARTERLY;
          break;

        case ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_SEMIANNUAL:
          modifiedProduct = ORDER_TYPE_SLEEP_MEMBERSHIP_VISIT_ONLY_SEMIANNUAL;
          break;
      }
    }

    trackVisitProductSelected(getVisitID(), modifiedProduct);

    this.setState({ selectedProduct: modifiedProduct, showError: false });
    setVisitProduct(modifiedProduct);
  };

  nextQuestion = () => {
    if (this.state.selectedProduct == "") {
      this.setState({ showError: "true" });
      return;
    }
    this.props.history.push(
      `/visits/${this.state.consultationType}/payment/order-details`
    );
    window.scrollTo(0, 0);
  };

  isSelected = (selectedProduct) => {
    return this.state.selectedProduct === selectedProduct;
  };

  render() {
    const { classes } = this.props;
    console.log(
      "getVisitDifferentPharmacyJSON(): ",
      getVisitDifferentPharmacyJSON()
    );

    return (
      <div className={classes.container} style={{ backgroundColor: "#3F3F82" }}>
        <GridContainer justifyContent="center">
          <GridItem xs={10} sm={10} md={8}>
            <h3
              style={{
                color: "#FFFFFF",
                fontFamily: "Spectral-SemiBold",
                fontSize: "32px",
                marginTop: "40px",
                // margin: "0 auto",
                textAlign: "center",
              }}
            >
              Pick a Sleep Treatment Plan
            </h3>
            {/* <p
              style={{
                color: "#FFFFFF",
                fontFamily: "BasisGrotesquePro-Regular",
                fontSize: "18px",
                lineHeight: "26px",
                // letterSpacing: "-0.21px"
              }}
            >
              Your preference will be shared with your doctor to determine the
              best treatment plan.
              <br />
            </p> */}
          </GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            className={classes.selectSleepProductPlansWrapper}
          >
            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes.cardConsultation}>
                <CardBody
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "0 2px",
                  }}
                >
                  <div className={classes.selectSleepProductWrapper}>
                    <div className={classes.selectProductTwoPackWrapper}>
                      <h4
                        className={classes.selectProductImageTitle}
                        style={{
                          marginBottom: 0,
                          color: kickBlue,
                          fontWeight: "bold",
                        }}
                      >
                        One Month Sleep Program
                      </h4>
                      <p
                        style={{
                          fontSize: "16px",
                          // textAlign: "center",
                          color: kickRed,
                        }}
                      >
                        $
                        {getSleepMailOrderOrVisitOnlyPrice(
                          ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_MONTHLY,
                          isEmpty(getVisitDifferentPharmacyJSON())
                        )}{" "}
                        - Medication with FREE Shipping
                        <br />
                        <span
                          style={{
                            // textAlign: "center",
                            fontSize: "15px",
                            color: kickNavy,
                          }}
                        >
                          {" "}
                          Starter Program
                        </span>
                      </p>

                      <ul
                        style={{
                          fontSize: "18px",
                          color: kickNavy,
                          lineHeight: "140%",
                        }}
                      >
                        <li style={{ paddingBottom: "2px" }}>
                          Always be prepared with a pack at home and another at
                          work.
                        </li>
                        <li style={{ paddingBottom: "2px" }}>
                          Two-pack refills without needing a new prescription.
                        </li>
                        <li style={{ paddingBottom: "2px" }}>
                          Your order lasts longer, so you can refill less often.
                        </li>
                      </ul>

                      <Button
                        style={{ backgroundColor: kickAmaOrange }}
                        onClick={async () => {
                          await this.handleSelection(
                            ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_MONTHLY
                          );

                          this.nextQuestion();
                        }}
                        className={classes.selectSleepProductButton}
                      >
                        Continue
                      </Button>
                    </div>
                  </div>

                  <div
                    style={{
                      height: "1px",
                      margin: "0 100px",
                      backgroundColor: "#3F3F82",
                    }}
                  />
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes.cardConsultation}>
                <CardBody
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "0 2px",
                  }}
                >
                  <div className={classes.selectSleepProductWrapper}>
                    <div className={classes.selectProductTwoPackWrapper}>
                      <h4
                        className={classes.selectProductImageTitle}
                        style={{
                          marginBottom: 0,
                          color: kickBlue,
                          fontWeight: "bold",
                          // fontWeight:
                          //   this.isSelected(ORDER_TYPE_PROP_2_PACK) ||
                          //   this.isSelected(ORDER_TYPE_PROP_2_PACK_FOLLOW_UP)
                          //     ? "bold"
                          //     : "",
                        }}
                      >
                        Three Month Sleep Program
                      </h4>
                      <p
                        style={{
                          fontSize: "16px",
                          // textAlign: "center",
                          color: kickRed,
                          fontWeight:
                            this.isSelected(ORDER_TYPE_PROP_2_PACK) ||
                            this.isSelected(ORDER_TYPE_PROP_2_PACK_FOLLOW_UP)
                              ? "bold"
                              : "",
                        }}
                      >
                        $
                        {getSleepMailOrderOrVisitOnlyPrice(
                          ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_QUARTERLY,
                          isEmpty(getVisitDifferentPharmacyJSON())
                        )}{" "}
                        - Medication with FREE Shipping
                        <br />
                        <span
                          style={{
                            // textAlign: "center",
                            fontSize: "15px",
                            color: kickNavy,
                          }}
                        >
                          {" "}
                          Most Popular Option
                        </span>
                      </p>

                      <ul
                        style={{
                          fontSize: "18px",
                          color: kickNavy,
                          lineHeight: "140%",
                        }}
                      >
                        <li style={{ paddingBottom: "2px" }}></li>
                        <li style={{ paddingBottom: "2px" }}>
                          Two-pack refills without needing a new prescription.
                        </li>
                        <li style={{ paddingBottom: "2px" }}>
                          3-month supplies after we find the right treatment for
                          you
                        </li>
                      </ul>
                      <Button
                        onClick={async () => {
                          await this.handleSelection(
                            ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_QUARTERLY
                          );

                          this.nextQuestion();
                        }}
                        className={classes.selectSleepProductButton}
                      >
                        Continue
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <Card className={classes.cardConsultation}>
                <CardBody
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "0 2px",
                  }}
                >
                  <div className={classes.selectSleepProductWrapper}>
                    <div className={classes.selectProductTwoPackWrapper}>
                      <h4
                        className={classes.selectProductImageTitle}
                        style={{
                          marginBottom: 0,
                          color: kickBlue,
                          fontWeight: "bold",
                        }}
                      >
                        Six Month Sleep Program
                      </h4>
                      <p
                        style={{
                          fontSize: "16px",
                          // textAlign: "center",
                          color: kickRed,
                        }}
                      >
                        $
                        {getSleepMailOrderOrVisitOnlyPrice(
                          ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_SEMIANNUAL,
                          isEmpty(getVisitDifferentPharmacyJSON())
                        )}{" "}
                        - Medication with FREE Shipping
                        <br />
                        <span
                          style={{
                            // textAlign: "center",
                            fontSize: "15px",
                            color: kickNavy,
                          }}
                        >
                          {" "}
                          Lowest Price Option
                        </span>
                      </p>

                      <ul
                        style={{
                          fontSize: "18px",
                          color: kickNavy,
                          lineHeight: "140%",
                        }}
                      >
                        <li style={{ paddingBottom: "2px" }}>
                          Always be prepared with a pack at home and another at
                          work.
                        </li>
                        <li style={{ paddingBottom: "2px" }}>
                          Two-pack refills without needing a new prescription.
                        </li>
                        <li style={{ paddingBottom: "2px" }}>
                          Your order lasts longer, so you can refill less often.
                        </li>
                      </ul>

                      <Button
                        onClick={async () => {
                          await this.handleSelection(
                            ORDER_TYPE_SLEEP_MEMBERSHIP_MAIL_ORDER_SEMIANNUAL
                          );

                          this.nextQuestion();
                        }}
                        className={classes.selectSleepProductButton}
                      >
                        Continue
                      </Button>
                    </div>
                  </div>

                  <div
                    style={{
                      height: "1px",
                      margin: "0 100px",
                      backgroundColor: "#3F3F82",
                    }}
                  />
                </CardBody>
              </Card>
            </GridItem>

            {/* <div style={{ color: "red", margin: "20px auto 6px auto" }}>
              <p style={{ textAlign: "center" }}>
                {this.state.showError ? "Please select an option above" : ""}
              </p>
            </div> */}
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

SelectProductSleep.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(consultationStyles)(SelectProductSleep);

// <div className={classes.center}>
//   <Link to="/visits/performance-anxiety-consultation">
//     <Button
//       round
//       color="primary"
//       style={{
//         marginTop: "30px",
//         marginBottom: "20px",
//         width: "300px"
//         // marginLeft: "80px"
//       }}
//     >
//       Continue
//     </Button>
//   </Link>
// </div>
